import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import CurrencyInput from 'react-currency-input-field';

import { setAlert } from '../../actions/alert';
import { crearPago } from '../../actions/clientes';

const NuevoPago = ({ pago, reestablecerPago }) => {

    const dispatch = useDispatch();

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [pagoData, setPagoData] = useState({
        id_cliente: null,
        monto: null,
        concepto: ''
    });

    const handleInputChange = ({ target }) => {
        setPagoData({
            ...pagoData,
            [target.name]: target.value
        });
    }

    const handleMontoChange = (value) => {
        setPagoData({
            ...pagoData,
            monto: value || null
        });
    }

    const handleProcesar = async () => {
        if(pagoData.monto && parseFloat(pagoData.monto) > 0){
            if(pagoData.concepto?.trim()){
                await setStatusProcesar(true);
                await dispatch(crearPago(pagoData));
                await handleCerrar();
                await setStatusProcesar(false);
            }else{
                await dispatch(setAlert('El concepto es requerido', 'danger'));
            }
        }else{
            await dispatch(setAlert('El monto debe ser mayor a cero', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setPagoData({
                id_cliente: null,
                monto: null,
                concepto: ''
            });
            setNuevoModal(false);
            reestablecerPago(null);
        }
    }

    useEffect(() => {
        if(pago?.cliente){
            setPagoData({
                ...pagoData,
                id_cliente: pago.cliente
            });
            setNuevoModal(true);
        }
    }, [pago]);

    return (
        <Modal show={nuevoModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Agregar abono a saldo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <CurrencyInput
                                    id="monto"
                                    name="monto"
                                    className="form-control text-center"
                                    value={pagoData.monto || ''}
                                    decimalsLimit={2}
                                    groupSeparator=","
                                    decimalSeparator="."
                                    onValueChange={(value) => handleMontoChange(value)}
                                />
                                <label htmlFor="monto">Monto del abono</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Concepto"
                                    id="concepto"
                                    name="concepto"
                                    value={pagoData.concepto}
                                    onChange={e => handleInputChange(e)}
                                />
                                <label htmlFor="concepto">Concepto</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default NuevoPago;
